var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 62,
    viewBox: "0 0 82 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 31C72.5 13.8792 58.6208 0 41.5 0C24.3792 0 10.5 13.8792 10.5 31C10.5 48.1208 24.3792 62 41.5 62C58.6208 62 72.5 48.1208 72.5 31Z",
    fill: "url(#paint0_linear_5_269)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.883 45.4668H45.9775L47.3552 52.0112H36.333L37.883 45.4668Z",
    fill: "#A8A9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.457 43.5945C19.4563 44.2024 19.5515 44.8044 19.7372 45.3662C19.923 45.928 20.1956 46.4384 20.5394 46.8682C20.8833 47.298 21.2916 47.6388 21.741 47.8709C22.1904 48.1031 22.6721 48.2221 23.1584 48.2212H60.1871C61.1688 48.2206 62.1101 47.733 62.8045 46.8655C63.4988 45.9981 63.8894 44.8216 63.8904 43.5945V41.6768H19.457V43.5945Z",
    fill: "#A8A9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2218 17.1582H24.1187C22.1813 17.1582 20.6084 18.6637 20.6084 20.5211V42.6633H62.7321V20.5211C62.7398 18.6637 61.1688 17.1582 59.2218 17.1582Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4248 52.6992H33.9248",
    stroke: "url(#paint1_linear_5_269)",
    strokeWidth: 1.86281,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.457 42.5623C19.4563 43.1702 19.5515 43.7722 19.7372 44.334C19.923 44.8957 20.1956 45.4062 20.5394 45.836C20.8833 46.2658 21.2916 46.6065 21.741 46.8387C22.1904 47.0709 22.6721 47.1899 23.1584 47.189H60.1871C61.1688 47.1883 62.1101 46.7008 62.8045 45.8333C63.4988 44.9658 63.8894 43.7894 63.8904 42.5623V40.6445H19.457V42.5623Z",
    fill: "url(#paint2_linear_5_269)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1977 12.8037H23.1611C22.1787 12.8037 21.2366 13.1929 20.5419 13.8856C19.8473 14.5784 19.457 15.5179 19.457 16.4976V40.8128H63.9018V16.4976C63.9013 15.5181 63.5109 14.5788 62.8163 13.8862C62.1218 13.1936 61.18 12.8042 60.1977 12.8037Z",
    fill: "url(#paint3_linear_5_269)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0171 44.7773C42.6829 44.7773 43.2226 44.2376 43.2226 43.5718C43.2226 42.906 42.6829 42.3662 42.0171 42.3662C41.3513 42.3662 40.8115 42.906 40.8115 43.5718C40.8115 44.2376 41.3513 44.7773 42.0171 44.7773Z",
    fill: "#6D6F75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0171 44.7773C42.6829 44.7773 43.2226 44.2376 43.2226 43.5718C43.2226 42.906 42.6829 42.3662 42.0171 42.3662C41.3513 42.3662 40.8115 42.906 40.8115 43.5718C40.8115 44.2376 41.3513 44.7773 42.0171 44.7773Z",
    fill: "url(#paint4_linear_5_269)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3253 14.1221H24.0198C22.0713 14.1221 20.4893 15.6876 20.4893 17.6191V40.6443H62.8559V17.6191C62.8636 15.6876 61.2835 14.1221 59.3253 14.1221Z",
    fill: "url(#paint5_linear_5_269)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3291 25.7173H31.264L32.7468 29.985L36.6331 21.4189L39.9535 28.9578L43.9798 22.9684L44.9696 32.1983L49.0669 25.6465H54.9327",
    stroke: "white",
    strokeWidth: 1.49025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4575 7.92402H50.1588C49.9797 7.90988 49.8021 7.96662 49.6646 8.08198C49.5271 8.19734 49.4406 8.36205 49.4238 8.5405V11.464H80.1925V8.53838C80.1752 8.36031 80.0885 8.19614 79.951 8.08122C79.8135 7.96631 79.6363 7.90985 79.4575 7.92402Z",
    fill: "#00245B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4336 10.3062C52.7679 10.3062 53.039 10.0359 53.039 9.7024C53.039 9.36895 52.7679 9.09863 52.4336 9.09863C52.0992 9.09863 51.8281 9.36895 51.8281 9.7024C51.8281 10.0359 52.0992 10.3062 52.4336 10.3062Z",
    fill: "#932F3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6806 10.3062C55.015 10.3062 55.2861 10.0359 55.2861 9.7024C55.2861 9.36895 55.015 9.09863 54.6806 9.09863C54.3463 9.09863 54.0752 9.36895 54.0752 9.7024C54.0752 10.0359 54.3463 10.3062 54.6806 10.3062Z",
    fill: "#FFBF60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9257 10.3062C57.2601 10.3062 57.5312 10.0359 57.5312 9.7024C57.5312 9.36895 57.2601 9.09863 56.9257 9.09863C56.5914 9.09863 56.3203 9.36895 56.3203 9.7024C56.3203 10.0359 56.5914 10.3062 56.9257 10.3062Z",
    fill: "#41934D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4238 11.4629H80.1946V33.5565C80.1946 33.8212 80.0892 34.075 79.9016 34.2621C79.7139 34.4492 79.4594 34.5544 79.1941 34.5544H50.4244C50.159 34.5544 49.9045 34.4492 49.7169 34.2621C49.5292 34.075 49.4238 33.8212 49.4238 33.5565V11.4629Z",
    fill: "url(#paint6_linear_5_269)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3603 8.96582C77.0817 8.97187 76.8102 9.05409 76.5753 9.20353C76.3404 9.35296 76.1512 9.56386 76.0283 9.81321C76.1445 10.0687 76.332 10.2853 76.5684 10.4373C76.8048 10.5892 77.0801 10.67 77.3613 10.67C77.6426 10.67 77.9179 10.5892 78.1543 10.4373C78.3907 10.2853 78.5782 10.0687 78.6943 9.81321C78.5713 9.56355 78.3817 9.35244 78.1465 9.20298C77.9112 9.05353 77.6392 8.97148 77.3603 8.96582Z",
    fill: "#005AE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3587 10.2938C77.4528 10.2938 77.5448 10.266 77.623 10.2138C77.7013 10.1617 77.7623 10.0876 77.7983 10.0009C77.8343 9.91415 77.8437 9.81874 77.8254 9.72669C77.807 9.63464 77.7617 9.55008 77.6951 9.48372C77.6286 9.41735 77.5438 9.37216 77.4515 9.35385C77.3592 9.33553 77.2635 9.34493 77.1765 9.38085C77.0896 9.41677 77.0153 9.47759 76.963 9.55563C76.9107 9.63366 76.8828 9.72541 76.8828 9.81927C76.8828 9.94512 76.9329 10.0658 77.0222 10.1548C77.1114 10.2438 77.2325 10.2938 77.3587 10.2938Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2237 17.3415C67.9432 17.6741 65.4259 15.6191 65.4259 15.6191C65.4259 15.6191 63.2739 17.8414 58.628 17.3415C58.628 17.3415 58.2669 26.0929 65.4259 29.3935C72.5955 26.0929 72.2237 17.3415 72.2237 17.3415Z",
    fill: "#77B280"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5094 15.6191C65.5094 15.6191 63.3171 17.7228 58.6351 17.405C58.6351 17.405 58.4736 26.1353 65.5094 29.3935",
    fill: "url(#paint7_linear_5_269)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.667 22.1045L64.6851 24.1171L68.1945 20.3652",
    stroke: "white",
    strokeWidth: 1.11769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_269",
    x1: 41.5,
    y1: 0,
    x2: 41.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_269",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_269",
    x1: 19.457,
    y1: 43.9168,
    x2: 63.8904,
    y2: 43.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_269",
    x1: 19.457,
    y1: 26.8083,
    x2: 63.9018,
    y2: 26.8083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_269",
    x1: 40.2757,
    y1: 43.4378,
    x2: 43.6245,
    y2: 43.4378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_269",
    x1: 20.4893,
    y1: 27.3832,
    x2: 62.8559,
    y2: 27.3832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BC60",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#55BC60",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_269",
    x1: 49.4238,
    y1: 11.3673,
    x2: 80.0794,
    y2: 34.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_269",
    x1: 6508.94,
    y1: 2437.57,
    x2: 6731.41,
    y2: 2437.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#268334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195723"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat4);
export default __webpack_public_path__ + "static/media/feat-4.4b5c576dfbf2551ff047248ac7603533.svg";
export { ForwardRef as ReactComponent };